import { createContext, useContext } from "react";

// 摘要裡的 @附件(業主 2026-09-25):
//   > 報價單中的摘要 打上小老鼠@ 可以標記附件名 (如果有附件的話) 沒有附件的話就只是單存符號
//
// 摘要存的就是純文字 `@原始檔名`;產 PDF 時後端把它換成「(見附件 N)」
// (`backend/app/exporters/attachment_refs.py`)。這裡只管打字時的那個下拉。

/**
 * 游標前面那一段是不是 `@片段`。是的話回片段(剛打 `@` 就是空字串),不是回 null。
 *
 * - `@` 前面緊貼英數字的不算 —— 那是 Email(`a@b.com`)。
 * - 片段裡有換行就不算:那已經是下一行的字了。
 */
export function mentionQuery(text: string, caret: number): string | null {
  const before = text.slice(0, caret);
  const at = before.lastIndexOf("@");
  if (at < 0) return null;
  const prev = at > 0 ? before[at - 1] : "";
  if (/[A-Za-z0-9._%+-]/.test(prev)) return null;
  const partial = before.slice(at + 1);
  if (/[\r\n]/.test(partial)) return null;
  return partial;
}

/** 把游標前那段 `@片段` 換成 `@檔名 `,回新的文字與游標位置。 */
export function insertMention(text: string, caret: number, name: string): { text: string; caret: number } {
  const at = text.slice(0, caret).lastIndexOf("@");
  const head = text.slice(0, at + 1) + name + " ";
  return { text: head + text.slice(caret), caret: head.length };
}

/**
 * 目前這張報價單的 id。報價單編輯器提供,明細列打 `@` 時拿它去撈這張單的附件。
 * 不另外一層一層傳 prop:中間隔著章節、表格兩層,它們都用不到這個值。
 */
export const QuoteIdContext = createContext<number | null>(null);

export function useQuoteId(): number | null {
  return useContext(QuoteIdContext);
}
